import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { FiSave } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations  from "../../hooks/useTranslations";

const VersionEdit = () => {
  const { id } = useParams();
  const nav      = useNavigate();

  /* i18n */
  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = useMemo(() => (k,d="") => translations[k] || d, [translations]);

  /* state */
  const [form, setForm]   = useState({ title:"", content:"", status:"active" });
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);

  /* ilk yükle */
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/versions/${id}`,{
          headers:{ Authorization:`Bearer ${localStorage.getItem("admin_token")}` }
        });
        setForm({ title:data.title, content:data.content, status:data.status });
        setLoaded(true);
      } catch (e) {
        toast.error(t("ERROR_GET", "Kayıt getirilemedi"));
        console.error(e);
      }
    })();
  }, [id, t]);

  /* handler’lar */
  const onInput  = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));
  const onEditor = c => setForm(p => ({ ...p, content:c }));

  const update = async () =>{
    if(!form.title.trim() || !form.content.trim()){
      toast.warn(t("WARNING_REQUIRED_FIELDS","Boş alanlar var"));
      return;
    }
    setSaving(true);
    try{
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/versions/${id}`, form ,{
        headers:{ Authorization:`Bearer ${localStorage.getItem("admin_token")}` }
      });
      toast.success(t("SUCCESS_UPDATED","Kaydedildi"));
 
    }catch(e){
      toast.error(t("ERROR_UPDATE","Güncellenemedi"));
      console.error(e);
    }finally{ setSaving(false); }
  };

  if(!loaded) return <p className="text-center py-5">{t("LOADING","Yükleniyor…")}</p>;

  return (
    <div className="container mt-4">
      <ToastContainer/>
      <div className="card card-body mb-4">
        <h3 className="fw-bold text-primary mb-3">
          {t("EDIT_VERSION_TITLE","Versiyonu Düzenle")}
        </h3>

        <div className="mb-3">
          <label className="form-label fw-bold">{t("VERSION_TITLE_LABEL","Başlık")}</label>
          <input name="title" className="form-control" value={form.title}
                 onChange={onInput}/>
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">{t("VERSION_CONTENT_LABEL","İçerik")}</label>
          <Editor
            tinymceScriptSrc="https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.6.1/tinymce.min.js"
            key={id}   
            value={form.content}
            onEditorChange={onEditor}
            init={{
              promotion:false, height:500,
              plugins:["advlist","autolink","link","image","lists","charmap",
                       "preview","anchor","pagebreak","searchreplace","wordcount",
                       "visualblocks","code","fullscreen","insertdatetime","media",
                       "table","emoticons","help"],
              toolbar:"undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | " +
                      "bullist numlist outdent indent | link image | " +
                      "print preview media fullscreen code | forecolor backcolor emoticons | help",
              content_style:"body { font-family:Helvetica,Arial,sans-serif; font-size:16px }",
              image_advtab:true,
              automatic_uploads:true,
              images_upload_url:`${process.env.REACT_APP_API_BASE_URL}/api/versions/upload`,
              images_upload_handler:null
            }}
          />
        </div>

        <div className="d-flex justify-content-center">
          <button className="btn btn-primary" disabled={saving} onClick={update}>
            <FiSave className="me-2"/>
            {saving ? t("SAVING","Kaydediliyor…") : t("SAVE_BTN","Kaydet")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VersionEdit;
